// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "pdfjsWorker" + "." + "54c3f7c4" + ".chunk.js";
};